<template>
  <b-modal id="assignment-view-modal" no-close-on-backdrop
           :modal-class="`adp-big-modal adp-big-modal__no_footer adp-big-modal__no_background`"
           :body-class="`adp-big-modal-body`" :header-class="`adp-big-modal-header`"
           @show="onShow">

    <template v-if="loading">
      {{ $t('voc.loading') }}
    </template>

    <template #modal-title>
      <div class="d-flex">
        <span class="modal-title adp-h2 adp-h2__modal">{{ activityName }}</span>
      </div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template v-if="!loading">
      <div class="adp-subtitle" style="padding-left: 0; margin-top: 0; position: relative">
        <span class="adp-h3">{{ $t('catalog.assignment_title') }} </span>
        <span class="adp-h3 adp-h3__green">{{ employees.length }} {{ $tc('idp.men', employees.length) }}</span>

        <span @mouseenter="showError = true" @mouseleave="showError = false">
          <button class="btn adp-btn" style="margin: 0 1.5rem 0 2rem" @click="showContextMenu()" v-if="selectedYear === currentYear"
                  :disabled="!Object.values(this.assignItems).length">
            {{ $t('voc.actions') }}
          </button>
        </span>

        <span v-tooltip.top-start="{ content: $t('idp.assignments_tooltip') }">
          <button class="btn adp-btn" style="margin: 0 1.5rem 0 2rem" v-if="selectedYear !== currentYear" disabled>
            {{ $t('voc.actions') }}
          </button>
        </span>

        <div class="actions-button-error" v-if="showError && !Object.values(this.assignItems).length">
          {{ $t('voc.warning_actions_employee') }}
        </div>

        <!-- Actions Context Menu -->
        <div class="adp-task--crud-actions" v-if="contextMenu.isVisible && selectedItemsStatuses.length"
             :style="cmStyles"
             v-click-outside="() => hideContextMenu()" ref="actions">
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canMassAssign(assignItems)"
               @click="massChangeStatusActivities('assigned')">
            {{ $t('idp.cm_assign_hr') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canMassReject(assignItems)"
               @click="massChangeStatusActivities('rejected')">
            {{ $t('idp.cm_reject') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canMassCancel(assignItems)"
               @click="massChangeStatusActivities('canceled')">
            {{ $t('idp.cm_cancel') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canMassDone(assignItems)"
               @click="massChangeStatusActivities('done')">
            {{ $t('idp.cm_mark_as_done') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canMassDeadlines(assignItems)"
               @click="setMassActivitiesDeadlines()">
            {{ $t('idp.cm_set_new_deadline') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="addMassActivitiesComments()">
            {{ $t('idp.cm_comment') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="attachMassActivitiesFiles()">
            {{ $t('idp.cm_attach_files') }}
          </div>
        </div>

        <div class="adp-report" style="display: inline-block;">
          <img src="/images/rectangle-yellow.svg" style="height: 35px">
          <img src="/images/download.svg" class="adp-report__download-list">
        </div>

        <div class="adp-year">
          <span class="adp-h2">{{ $t('idp.for') }}&nbsp;</span>
          <span class="nav-item dropdown">
            <a id="navbarAppDropdown" class="navbar-brand adp-h3 adp-h3__green" href="#" role="button"
               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="font-size: 24px">
              {{ selectedYear }} г. <img src="/images/arrow_down.svg" alt="">
            </a>

              <div class="dropdown-menu dropdown-menu-right adp-dropdown" aria-labelledby="navbarAppDropdown">
              <span v-for="year in IDPYears"
                    @click="changeYear(year)"
                    class="dropdown-item adp-lang-item">{{ year }}
                <template v-if="selectedYear === year">&nbsp;&nbsp;&nbsp;
                  <img src="/images/check-mark.svg" alt="">
                </template>
              </span>
              </div>
            </span>
        </div>
      </div>
      <div class="adp-grid-table">
        <div class="adp-grid-row adp-grid-row__assignment_view">
          <div class="adp-grid-cell adp-grid-cell__chbox">
            <b-form-checkbox v-model="selectAll"
                             :indeterminate="selectAllIndeterminate"
                             @change="selectAllHandler($event)">&nbsp;
            </b-form-checkbox>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingPernumber !== null}"
                  @click="sortChange('sortingPernumber')">
              {{ $t('voc.table_pernumber') }} <img :src="getSortingIcon(sortingPernumber)" alt="sort">
            </span>
            <input @input="filterEmployee" type="text" class="adp-input adp-input__catalog adp-input-search"
                   v-model="filterPernumber">
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingName !== null}"
                  @click="sortChange('sortingName')">
              {{ $t('voc.table_fullname') }} <img :src="getSortingIcon(sortingName)" alt="sort">
            </span>
            <input @input="filterEmployee" type="text" class="adp-input adp-input__catalog adp-input-search"
                   v-model="filterName">
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingPosition !== null}"
                  @click="sortChange('sortingPosition')">
              {{ $t('voc.table_position') }} <img :src="getSortingIcon(sortingPosition)" alt="sort">
            </span>
            <my-dropdown :options="positions" :init-selected="filterPosition" :has-select-all="true" :localize="false"
                         v-on:my-change="onDropdownUpdate($event, 'filterPosition')">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingSubdivision !== null}"
                  @click="sortChange('sortingSubdivision')">
              {{ $t('voc.table_subdivision') }} <img :src="getSortingIcon(sortingSubdivision)" alt="sort">
            </span>
            <my-dropdown :options="subdivisions" :init-selected="filterSubdivision" :has-select-all="true"
                         :localize="false"
                         v-on:my-change="onDropdownUpdate($event, 'filterSubdivision')">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingStatus !== null}"
                  @click="sortChange('sortingStatus')">
              {{ $t('voc.table_status_idp') }} <img :src="getSortingIcon(sortingStatus)" alt="sort">
            </span>
            <my-dropdown :options="IDPStatuses" :init-selected="filterStatus" :has-select-all="true"
                         v-on:my-change="onDropdownUpdate($event, 'filterStatus')">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingActivityStatus !== null}"
                  @click="sortChange('sortingActivityStatus')">
              {{ $t('voc.table_status_activity') }} <img :src="getSortingIcon(sortingActivityStatus)" alt="sort">
            </span>
            <my-dropdown :options="activityStatuses" :init-selected="filterActivityStatus" :has-select-all="true"
                         v-on:my-change="onDropdownUpdate($event, 'filterActivityStatus')">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingDeadline !== null}"
                  @click="sortChange('sortingDeadline')">
              {{ $t('voc.table_deadline') }} <img :src="getSortingIcon(sortingDeadline)" alt="sort">
            </span>
            <my-dropdown :options="deadlines" :init-selected="filterDeadline" :has-select-all="true"
                         v-on:my-change="onDropdownUpdate($event, 'filterDeadline')" :localize="false">
            </my-dropdown>
          </div>
        </div>
        <div style="cursor: pointer" class="adp-grid-row adp-grid-row__assignment_view"
             v-for="(item, i) in filteredEmployees" :key="i" v-if="employees"
             :class="{'adp-grid-row__warning': item.has_expired_activities}">
          <div class="adp-grid-cell adp-grid-cell__chbox-hr">
            <b-form-checkbox v-model="item.is_checked" @change="selectEvent"/>
          </div>
          <div class="adp-grid-cell adp-grid-cell__code">
            {{ item.pernumber }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title">
            {{ item.fio }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title">
            {{ item.position_name }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title">
            {{ item.subdivision }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title">
            <div v-if="item.has_expired_activities" style="position: relative">
              {{ $t(`idp.${item.idp_status}`) }}
              <div style="color: #E02020; font-size: 12px" v-if="item.has_new_wishes">
                {{ $t('idp.has_expired_activities') }}
              </div>
              <img src="/images/expired-activity.svg" style="position: absolute;left: 211px;top: 11px;height: 20px">
            </div>
            <div v-else>
              {{ $t(`idp.${item.idp_status}`) }}
              <div style="color: #E6C600; font-size: 12px" v-if="item.has_new_wishes">
                {{ $t('idp.has_new_wishes') }}
              </div>
            </div>
          </div>
          <div class="adp-grid-cell adp-grid-cell__title" :style="`color: ${textColor(item.activity_status)}`">
            {{ $t(`idp.${item.activity_status}`) }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title">
            {{ $t('idp.till') }} {{ item.deadline }}
          </div>
        </div>
      </div>

      <div class="adp-task" v-if="!filteredEmployees.length">
        <div class="adp-task--body">
              <span class="adp-p adp-p__grey adp-p__bold">
                {{ $t('idp.not_found_assignments') }}
              </span>
        </div>
      </div>

    </template>

    <div v-if="Object.values(assignItems).length" v-for="(activity, i) in Object.values(assignItems)">
      <change-deadline-modal :activity="activity" v-on:deadline-updated="reload()" :activity-index="i+1"/>
    </div>

    <mass-idp-files-attach-modal :activities="[...Object.values(assignItems)]"
                                 :viewer-pernumber="Number(viewerPernumber)"
                                 v-on:files-attached="reload()"/>

    <mass-comments-create-modal :activities="[...Object.values(assignItems)]"
                                :viewer-pernumber="Number(this.viewerPernumber)"
                                v-on:comments-created="reload()"/>

  </b-modal>
</template>

<script>
import MyDropdown from "../MyDropdown";
import api from "../../api";
import ChangeDeadlineModal from "./ChangeDeadlineModal";
import MassIdpFilesAttachModal from "./MassIdpFilesAttachModal";
import MassCommentsCreateModal from "./MassCommentsCreateModal";
import Vue from "vue";


export default {
  name: "AssignmentsViewModal",
  components: {
    'my-dropdown': MyDropdown,
    'change-deadline-modal': ChangeDeadlineModal,
    'mass-idp-files-attach-modal': MassIdpFilesAttachModal,
    'mass-comments-create-modal': MassCommentsCreateModal,
  },
  props: {
    activityId: {
      type: Number,
      required: true,
    },
    activityName: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      showError: false,

      loading: true,
      userId: null,

      selectAll: false,
      selectAllIndeterminate: false,

      employees: [],
      filteredEmployees: [],
      assignItems: {},

      sortingPernumber: null,
      sortingName: null,
      sortingPosition: null,
      sortingSubdivision: null,
      sortingStatus: null,
      sortingActivityStatus: null,
      sortingDeadline: null,

      filterPernumber: '',
      filterName: '',
      filterPosition: [],
      filterSubdivision: [],
      filterStatus: [],
      filterActivityStatus: [],
      filterDeadline: [],

      positions: [],
      subdivisions: [],
      IDPStatuses: [],
      activityStatuses: [],
      deadlines: [],

      contextMenu: {
        isVisible: false,
        top: 0,
        left: 0,
        right: 0,
      },
      selectedItemsStatuses: [],
      selectedItemsExpire: [],
      selectedItemsInconsistent: [],

      selectedYear: 0,
      currentYear: new Date().getFullYear(),
      IDPYears: [new Date().getFullYear() - 1, new Date().getFullYear()],

      viewerPernumber: 0,
    }
  },
  computed: {
    cmStyles() {
      return {
        top: '40px',
        left: `${this.contextMenu.left}px`,
        right: 'unset',
      };
    },
  },
  watch: {},
  methods: {
    async onShow() {
      this.selectedYear = window.IDP.currentYear ? window.IDP.currentYear : new Date().getFullYear();
      this.userId = window.IDP.pernumber;

      this.loading = true;
      await this.getEmployees();

      const uniquePositions = [...new Set(this.filteredEmployees.map(item => item.position_name))];
      this.positions = uniquePositions.map(item => ({id: String(item), code: String(item)}));
      const uniqueSubdivisions = [...new Set(this.filteredEmployees.map(item => item.subdivision))];
      this.subdivisions = uniqueSubdivisions.map(item => ({id: String(item), code: String(item)}));
      const uniqueIDPStatuses = [...new Set(this.filteredEmployees.map(item => item.idp_status))];
      this.IDPStatuses = uniqueIDPStatuses.map(item => ({id: String(item), code: String(item)}));
      const uniqueActivityStatuses = [...new Set(this.filteredEmployees.map(item => item.activity_status))];
      this.activityStatuses = uniqueActivityStatuses.map(item => ({id: String(item), code: String(item)}));
      const uniqueDeadlines = [...new Set(this.filteredEmployees.map(item => item.deadline))];
      this.deadlines = uniqueDeadlines.map(item => ({id: String(item), code: String(item)}));

      this.viewerPernumber = window.IDP.pernumber;

      this.loading = false;
    },
    filterEmployee() {
      function dynamicSort(property) {
        let sortOrder = 1;
        if (property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function (a, b) {
          let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
          return result * sortOrder;
        }
      }

      let filteredEmployees = this.employees;
      if (this.filterPernumber) {
        this.filterPernumber.length > 0
          ? filteredEmployees = filteredEmployees.filter(el => String(el.pernumber).includes(String(this.filterPernumber)))
          : filteredEmployees = filteredEmployees.filter(el => el.pernumber);
      }
      if (this.filterName) {
        this.filterName.length > 0
          ? filteredEmployees = filteredEmployees.filter(el => {
            return String(el.fio).toLowerCase().includes(this.filterName)
              || String(el.fio).includes(this.filterName)
          })
          : filteredEmployees = filteredEmployees.filter(el => el.fio);
      }
      if (this.filterPosition.length > 0) {
        filteredEmployees = filteredEmployees.filter(el => this.filterPosition.includes(el.position_name));
      }
      if (this.filterSubdivision.length > 0) {
        filteredEmployees = filteredEmployees.filter(el => this.filterSubdivision.includes(el.subdivision));
      }
      if (this.filterStatus.length > 0) {
        filteredEmployees = filteredEmployees.filter(el => this.filterStatus.includes(el.idp_status));
      }
      if (this.filterActivityStatus.length > 0) {
        filteredEmployees = filteredEmployees.filter(el => this.filterActivityStatus.includes(el.activity_status));
      }
      if (this.filterDeadline.length > 0) {
        filteredEmployees = filteredEmployees.filter(el => this.filterDeadline.includes(el.deadline));
      }

      // возвращаем сортировку в исходное положение(сортируем по pernumber)
      filteredEmployees = filteredEmployees.sort(dynamicSort('pernumber'));

      if (this.sortingPernumber) {
        let co = this.sortingPernumber === 'desc' ? '-' : '';
        filteredEmployees = filteredEmployees.sort(dynamicSort(`${co}pernumber`));
      } else if (this.sortingName) {
        let co = this.sortingName === 'desc' ? '-' : '';
        filteredEmployees = filteredEmployees.sort(dynamicSort(`${co}fio`));
      } else if (this.sortingPosition) {
        let co = this.sortingPosition === 'desc' ? '-' : '';
        filteredEmployees = filteredEmployees.sort(dynamicSort(`${co}position_name`));
      } else if (this.sortingSubdivision) {
        let co = this.sortingSubdivision === 'desc' ? '-' : '';
        filteredEmployees = filteredEmployees.sort(dynamicSort(`${co}subdivision`));
      } else if (this.sortingStatus) {
        let co = this.sortingStatus === 'desc' ? '-' : '';
        filteredEmployees = filteredEmployees.sort(dynamicSort(`${co}idp_status`));
      } else if (this.sortingActivityStatus) {
        let co = this.sortingActivityStatus === 'desc' ? '-' : '';
        filteredEmployees = filteredEmployees.sort(dynamicSort(`${co}activity_status`));
      } else if (this.sortingDeadline) {
        let co = this.sortingDeadline === 'desc' ? '-' : '';
        filteredEmployees = filteredEmployees.sort(dynamicSort(`${co}deadline`));
      }

      filteredEmployees.forEach(el => el.is_checked = false);
      this.filteredEmployees = filteredEmployees;
    },
    async getEmployees() {
      try {
        const resp = await api.getAssignments(this.$role, this.activityId, this.userId, this.selectedYear);
        this.employees = resp.data.users;
      } catch (e) {
        console.error(e);
      }
      this.filterEmployee();
    },
    selectAllHandler(event) {
      this.filteredEmployees = this.filteredEmployees.map(el => {
        el.is_checked = event;
        return el
      });
      this.selectAll = event;
      this.selectAllIndeterminate = false;
      this.updateItemsChecked();
    },
    updateItemsChecked() {
      let items = {};
      let assignedItems = this.filteredEmployees.filter(el => el.is_checked).map(el => ({...el}));

      assignedItems.forEach(item => {
        items[item.pernumber] = item
      })

      this.assignItems = items;
      Object.values(this.assignItems).map(item => {
        item.status = item.activity_status;
        item.type = item.activity_type;
        item.name = this.activityName;
        item.id = item.learning_activity_id;
      });
    },
    selectEvent() {
      let checkedElementsCnt = this.filteredEmployees.filter(el => el.is_checked).length;
      if (this.filteredEmployees.length === checkedElementsCnt) {
        this.selectAll = true;
        this.selectAllIndeterminate = false;
      } else if (this.filteredEmployees.length > checkedElementsCnt && checkedElementsCnt > 0) {
        this.selectAll = false;
        this.selectAllIndeterminate = true;
      } else {
        this.selectAll = false;
        this.selectAllIndeterminate = false;
      }

      this.updateItemsChecked();
    },
    getSortingIcon(val) {
      if (val === null) {
        return '/images/sort.svg';
      } else if (val === 'asc') {
        return '/images/sort_active_asc.svg';
      } else if (val === 'desc') {
        return '/images/sort_active_desc.svg';
      }
    },
    sortChange(prop) {
      if (this[prop] === null) {
        this[prop] = 'asc';
      } else if (this[prop] === 'asc') {
        this[prop] = 'desc';
      } else if (this[prop] === 'desc') {
        this[prop] = null;
      }

      this.filterEmployee();
    },
    onDropdownUpdate(e, property) {
      this[property] = e;
      this.filterEmployee();
    },
    showContextMenu() {
      if (!Object.values(this.assignItems).length) {
        this.showError = true;
        setTimeout(() => this.showError = false, 2000)
        return;
      }
      this.contextMenu.isVisible = true;

      this.selectedItemsStatuses = Object.values(this.assignItems).map(item => item.status);
      this.selectedItemsExpire = Object.values(this.assignItems).map(item => item.has_expired_activities);
      this.selectedItemsInconsistent = Object.values(this.assignItems).map(item => item.has_inconsistent_activities);

      this.$nextTick(() => {
        this.contextMenu.left = Number(event.pageX) - 50;
      });
    },
    hideContextMenu() {
      this.contextMenu.isVisible = false;
    },
    canMassAssign(items) {
      let isCan = true;
      Object.values(items).forEach(item => {
        if (this.canAssignActivity(item, item.idp_status, this.$role) === false) isCan = false;
      })
      return isCan;
    },
    canMassReject(items) {
      let isCan = true;
      Object.values(items).forEach(item => {
        if (this.canRejectActivity(item, item.idp_status, this.$role) === false) isCan = false;
      })
      return isCan;
    },
    canMassCancel(items) {
      let isCan = true;
      Object.values(items).forEach(item => {
        if (this.canCancelActivity(item, item.idp_status, this.$role) === false) isCan = false;
      })
      return isCan;
    },
    canMassDone(items) {
      let isCan = true;
      Object.values(items).forEach(item => {
        if (this.canMarkAsDone(item, item.idp_status, this.$role) === false) isCan = false;
      })
      return isCan;
    },
    canMassDeadlines(items) {
      let isCan = true;
      Object.values(items).forEach(item => {
        if (this.canChangeDeadline(item, item.idp_status, this.$role) === false) isCan = false;
      })
      return isCan;
    },
    async massChangeStatusActivities(status) {
      const data = {ids: Object.values(this.assignItems).map(item => item.learning_activity_id), status: status};
      await api.massActivityChangeStatus(data);
      await this.reload();
    },
    async setMassActivitiesDeadlines() {
      await this.$bvModal.show('change-deadline-modal');
    },
    async addMassActivitiesComments() {
      await this.$bvModal.show('mass-comments-create-modal');
    },
    async attachMassActivitiesFiles() {
      await this.$bvModal.show('mass-idp-files-attach-modal');
    },
    async reload() {
      await this.$bvModal.hide('mass-idp-files-attach-modal');
      Vue.set(this, 'assignItems', {});
      this.selectAll = false;
      this.selectAllIndeterminate = false;
      this.contextMenu.isVisible = false;
      await this.getEmployees();
    },
    changeYear(val) {
      this.selectedYear = val;
      this.getEmployees();
    },
    textColor(status) {
      if (status === 'draft') return '#6D7278';
      if (status === 'done') return '#509A01';
      if (status === 'rejected') return '#E02020';
      return '#E6C600';
    },
  },
}
</script>

<style>
</style>
